'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useEffect, useRef, useState } from 'react';
import { cn } from '@/lib/utils';
const COLLAPSED_SEO_HEIGHT = 560;
type GenreSeoDescriptionProps = {
  seoDescription: string;
};
export default function GenreSeoDescription(t0) {
  const $ = _c(21);
  const {
    seoDescription
  } = t0;
  const t = useTranslations();
  const seoContentRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(true);
  const [hasOverflow, setHasOverflow] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const content = seoContentRef.current;
      if (!content) {
        setHasOverflow(false);
        return;
      }
      setHasOverflow(content.scrollHeight > COLLAPSED_SEO_HEIGHT);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== seoDescription) {
    t2 = [seoDescription];
    $[1] = seoDescription;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  const t3 = !isExpanded && hasOverflow && "max-h-[560px] overflow-hidden";
  let t4;
  if ($[3] !== t3) {
    t4 = cn("relative", t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== seoDescription) {
    t5 = <div ref={seoContentRef} className="text-vive-primary-20 [&_a]:text-vive-brand-50 [&_a]:hover:text-vive-brand-40 [&_a]:active:text-vive-brand-60 [&_blockquote]:border-vive-primary-60 [&_li]:marker:text-vive-primary-30 [&_hr]:bg-vive-primary-40 [&_a]:underline [&_a]:underline-offset-2 [&_a]:transition-colors [&_blockquote]:my-4 [&_blockquote]:border-l-2 [&_blockquote]:pl-4 [&_em]:italic [&_h1]:mt-8 [&_h1]:mb-4 [&_h1]:text-[30px] [&_h1]:leading-10 [&_h1]:font-extrabold [&_h1]:tracking-[0.12px] [&_h2]:mt-7 [&_h2]:mb-3 [&_h2]:text-[24px] [&_h2]:leading-8 [&_h2]:font-semibold [&_h2]:tracking-[0.15px] [&_h3]:mt-6 [&_h3]:mb-3 [&_h3]:text-[18px] [&_h3]:leading-8 [&_h3]:font-semibold [&_h3]:tracking-[0.2px] [&_hr]:my-7 [&_hr]:h-px [&_hr]:border-0 [&_li]:text-[16px] [&_li]:leading-6 [&_li]:tracking-[0.2px] [&_ol]:my-4 [&_ol]:list-decimal [&_ol]:pl-6 [&_p]:my-3 [&_p]:text-[16px] [&_p]:leading-6 [&_p]:tracking-[0.2px] [&_p:last-child]:mb-0 [&_strong]:font-semibold [&_ul]:my-4 [&_ul]:list-disc [&_ul]:pl-6" dangerouslySetInnerHTML={{
      __html: seoDescription
    }} />;
    $[5] = seoDescription;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== hasOverflow || $[8] !== isExpanded) {
    t6 = !isExpanded && hasOverflow ? <div className="pointer-events-none absolute right-0 bottom-0 left-0 h-80 bg-linear-to-t from-[rgba(29,29,36,0.8)] to-transparent" /> : null;
    $[7] = hasOverflow;
    $[8] = isExpanded;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== hasOverflow || $[15] !== isExpanded || $[16] !== t) {
    t8 = hasOverflow ? <button type="button" className="text-vive-brand-50 hover:text-vive-brand-40 active:text-vive-brand-60 mt-4 text-[16px] leading-6 font-normal tracking-[0.2px] underline underline-offset-2 transition-colors" onClick={() => setIsExpanded(_temp)}>{isExpanded ? t("worlds-landing.genre.show-less") : t("worlds-landing.genre.show-more")}</button> : null;
    $[14] = hasOverflow;
    $[15] = isExpanded;
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <section className="mx-auto mt-8 mb-16 w-full pb-20"><div className="bg-vive-ghost-white rounded-[15px] px-4 py-2 md:px-6 md:py-4">{t7}{t8}</div></section>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}
function _temp(prev) {
  return !prev;
}